import * as R from 'ramda'
import { Question } from '../../Models/Question'
import SkipLogic from '../../Models/SkipLogic'

const toSkipLogicModels = (arr) => (Array.isArray(arr)
    ? arr.map((l) => (l instanceof SkipLogic ? l : new SkipLogic(l)))
    : [])

const buildSkipLogicAdapter = (fullSurvey, surveyQuestions) => {
    const raw = R.pathOr(fullSurvey, ['survey'], fullSurvey)
    const skipLogic = toSkipLogicModels(R.pathOr([], ['skipLogic'], raw))

    const questions = (Array.isArray(surveyQuestions) ? surveyQuestions : []).reduce((acc, q) => {
        const model = q?.question ? Question.fromJSON(q.question) : null
        if (model) {
            acc.push({
                id: q.pageQuestionId,
                parentId: q.parentId ?? q.inheritedPageQuestionId ?? null,
                question: model,
            })
        }
        return acc
    }, [])

    return {
        pages: [{ id: 'all', questions }],
        skipLogic,
        metadata: R.pathOr({}, ['metadata'], raw),
    }
}

export default buildSkipLogicAdapter
